import clsx from "clsx";
import { ExchangeIcon } from "@/shared/icons";
import InventoryCloseButton from "@/domains/inventory/components/InventoryCloseButton";

type Props = {
  onClose: () => void;
};

export default function InventoryTradeExchangeHeader({ onClose }: Props) {
  return (
    <div
      className={clsx(
        "rounded-b-[1rem] px-7.5 h-[4.875rem] w-full",
        "flex items-center gap-1.5 bg-gradient-to-r from-[#2C2C2C]/30 via-transparent to-dark-800/60",
      )}
    >
      <div className="flex items-center gap-3">
        <ExchangeIcon size={24} />
        <div className="text-18 font-bold uppercase">ОБМЕН С ИГРОКОМ</div>
      </div>

      <InventoryCloseButton onClick={onClose} />
    </div>
  );
}
